import { default as _91token_93oiLK5sWN81Meta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/[token].vue?macro=true";
import { default as iframempD0Pd8foFMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/iframe.vue?macro=true";
import { default as indexXJ956oAQwFMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/index.vue?macro=true";
import { default as infoiQQ1hw4vvhMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/info.vue?macro=true";
import { default as journeyjDiezFCbZqMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/journey.vue?macro=true";
import { default as _91token_93vDhVJWFLyDMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/journeys/[token].vue?macro=true";
import { default as _91id_937t2D99H72zMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/s/[id].vue?macro=true";
import { default as scanner2xA80kklw2Meta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/scanner.vue?macro=true";
import { default as _91id_93iDrc4PK1rqMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/scenes/[id].vue?macro=true";
import { default as _91challengeId_93EeQ7SOgGiJMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/static/promoter/[contentVersionId]/[challengeId].vue?macro=true";
import { default as registration6S3tEhrnNUMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/static/registration.vue?macro=true";
import { default as _91batchId_93qVwxlpmFjvMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/static/results/[batchId].vue?macro=true";
import { default as _91groupId_93X2uh4CSTErMeta } from "/home/runner/work/wdd/wdd/frontend/xaver/pages/static/video/[groupId].vue?macro=true";
export default [
  {
    name: "token",
    path: "/:token()",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/[token].vue").then(m => m.default || m)
  },
  {
    name: "iframe",
    path: "/iframe",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/iframe.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/info.vue").then(m => m.default || m)
  },
  {
    name: "journey",
    path: "/journey",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/journey.vue").then(m => m.default || m)
  },
  {
    name: "journeys-token",
    path: "/journeys/:token()",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/journeys/[token].vue").then(m => m.default || m)
  },
  {
    name: "s-id",
    path: "/s/:id()",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/s/[id].vue").then(m => m.default || m)
  },
  {
    name: "scanner",
    path: "/scanner",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/scanner.vue").then(m => m.default || m)
  },
  {
    name: "scenes-id",
    path: "/scenes/:id()",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/scenes/[id].vue").then(m => m.default || m)
  },
  {
    name: "static-promoter-contentVersionId-challengeId",
    path: "/static/promoter/:contentVersionId()/:challengeId()",
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/static/promoter/[contentVersionId]/[challengeId].vue").then(m => m.default || m)
  },
  {
    name: "static-registration",
    path: "/static/registration",
    meta: registration6S3tEhrnNUMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/static/registration.vue").then(m => m.default || m)
  },
  {
    name: "static-results-batchId",
    path: "/static/results/:batchId()",
    meta: _91batchId_93qVwxlpmFjvMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/static/results/[batchId].vue").then(m => m.default || m)
  },
  {
    name: "static-video-groupId",
    path: "/static/video/:groupId()",
    meta: _91groupId_93X2uh4CSTErMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/xaver/pages/static/video/[groupId].vue").then(m => m.default || m)
  }
]